import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 34,
  },
  path: {
    fill: '#48FF9B',
  },
});
const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 285"
    >
			<path d="M136.4,257.2c-48.2,0-87.2-39.1-87.3-87.2v-13.1c-18-3.1-29.1-9.3-36-15.4C4.7,134,0,124.5,0,114.8
				c0-6.6,2.2-16.4,12.6-26c8.9-8.2,21.8-14.4,36.7-18.1C51.4,31.1,84.2,0.1,123.9,0c19.7,0,38.7,8,52.5,22.1
				c14.3,14.4,22.4,33.6,22.3,52.8c-0.1,11.3-1.9,21.3-5.4,30.2c18.6,16.3,30.5,37.9,30.5,64.8c0,24.5-9,46.8-25.3,62.8
				C182.4,248.5,160.3,257.2,136.4,257.2z M81.6,158.6v11.3c0,30.2,24.5,54.7,54.8,54.8c32.2,0,54.8-22.5,54.8-54.8
				c0-14.7-5.8-27.6-17.2-38.5c-15.6,13.1-38.7,21.4-70.4,25.4C95.6,157.8,88.3,158.4,81.6,158.6z M81.6,99.4v26.7
				c5.4-0.2,11.3-0.7,17.8-1.6c20.3-2.5,34.5-6.8,44.3-12c-16.1-6.8-35.4-11.3-55.1-12.8C86.3,99.6,83.9,99.5,81.6,99.4z
				 M32.7,114.9c1.1,2.1,5.7,6.2,16.5,8.8v-19.1l-1.3,0.5C37.7,109,33.7,113.2,32.7,114.9z M82.3,67c2.9,0,5.8,0.1,8.7,0.4
				c26,2,52,8.4,74.1,19.3c0.7-4,1.1-8,1-12c0.1-10.4-4.7-21.5-12.8-29.6c-7.7-7.9-18.3-12.4-29.4-12.5C103.6,32.6,86.1,47,82.3,67z
				"
        fill='#48FF9B'/>

      <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="26.6153" y1="814.6947" x2="64.4269" y2="796.9509" gradientTransform="matrix(1 0 0 1 0 -716)">
          <stop  offset="0.247" stopColor='#48FF9B' />
          <stop  offset="0.3762" stopColor='#48F59B' />
          <stop  offset="0.5926" stopColor='#48DB9B'/>
          <stop  offset="0.868" stopColor='#48B29B'/>
          <stop  offset="1" stopColor='#489B9B'/>
			</linearGradient>
      
			<path fill='#48FF9B' d="M22.2,81.6l15.5,28.6c8.4-5.6,18.2-8.4,27.4-9.7L63.3,68C36.4,71.3,22.2,81.6,22.2,81.6z"/>
			
				<linearGradient id="SVGID_00000121256527903086559480000009257794904469158565_" gradientUnits="userSpaceOnUse" x1="64.4136" y1="800.5295" x2="107.1331" y2="799.647" gradientTransform="matrix(1 0 0 1 0 -716)">
				<stop  offset="0" stopColor='#489B9B'/>
				<stop  offset="0.1722" stopColor='#48AF9B'/>
				<stop  offset="0.5228" stopColor='#48E29B'/>
				<stop  offset="0.7017" stopColor='#48FF9B'/>
			</linearGradient>
      
			<path fill='url(#SVGID_00000121256527903086559480000009257794904469158565_)' d="M63.3,68l1.9,32.4
				c16-2.3,35.4,0.6,35.4,0.6l4.3-32.2C87.7,66.3,73.5,66.8,63.3,68z"/>
			
				<linearGradient id="SVGID_00000170973987405375893080000016486439510373335455_" gradientUnits="userSpaceOnUse" x1="65.35" y1="890.2" x2="65.35" y2="790.1" gradientTransform="matrix(1 0 0 1 0 -716)">
				<stop  offset="2.790179e-03" stopColor='#48FF9B'/>
				<stop  offset="0.3011" stopColor='#489B9B' stopOpacity='0.7'/>
				<stop  offset="0.3973" stopColor='#48BA9B' stopOpacity='0.77'/>
				<stop  offset="0.534" stopColor='#48DF9B' stopOpacity='0.8696'/>
				<stop  offset="0.6442" stopColor='#48F69B' stopOpacity='0.9498' />
				<stop  offset="0.7132" stopColor='#48FF9B' />
			</linearGradient>
			
				<rect x="49.1" y="74.1" fill='url(#SVGID_00000170973987405375893080000016486439510373335455_)' width="32.5" height="100.1"/>
			
				<linearGradient id="SVGID_00000029021598976708026720000007244198388556027302_" gradientUnits="userSpaceOnUse" x1="176.6629" y1="829.1903" x2="206.0679" y2="859.2208" gradientTransform="matrix(1 0 0 1 0 -716)">
				<stop  offset="0" stopColor='#489B9B' stopOpacity='0.8'/>
				<stop  offset="0.5876" stopColor='#48FF9B'/>

			</linearGradient>
			<path fill='url(#SVGID_00000029021598976708026720000007244198388556027302_)' d="M186.7,99.7c-6.7,8.4-13.4,16.9-20,25.5
				c15.9,12,20,23.7,20,23.7l27.7-17.5C207.3,118.1,197.2,107.7,186.7,99.7z"/>
			
				<linearGradient id="SVGID_00000163036070216799811580000013332663813310765759_" gradientUnits="userSpaceOnUse" x1="133.7753" y1="806.1831" x2="181.2823" y2="829.9461" gradientTransform="matrix(1 0 0 1 0 -716)">
				<stop  offset="0.2118" stopColor='#48FF9B'/>
				<stop  offset="1" stopColor='#489B9B' stopOpacity="0.8"/>
			  </linearGradient>

			<path fill='url(#SVGID_00000163036070216799811580000013332663813310765759_)' d="M141.5,77.1l-12.6,30.1
				c16.9,4.8,29.1,11.4,37.7,17.9c6.7-8.6,13.3-17.1,20-25.5C164.9,83.2,141.5,77.1,141.5,77.1z"/>

			<path fill='#48FF9B' d="M74.2,158.8c-22.6,0-46-4-61-17.3C4.7,134,0,124.5,0,114.8h32.5c0-0.2,0-0.3,0-0.5c1,3.6,15.9,16.6,67,10.2
				c66.4-8.3,66.6-35.4,66.7-50c0.1-10.4-4.7-21.5-12.8-29.6c-7.7-7.9-18.3-12.4-29.4-12.5c-23.4,0-42.3,18.9-42.3,42.3l0,0H49.1
				C49.2,33.5,82.6,0,123.9,0c19.7,0,38.7,8,52.5,22.1c14.3,14.4,22.4,33.6,22.3,52.8c-0.2,23.1-7.5,40.9-22.3,54.5
				c-15.6,14.3-39.5,23.3-72.8,27.5C93.7,158.1,84,158.7,74.2,158.8z"/>
    </svg>
  );
};

export default LogoIcon;
